module.exports = __webpack_public_path__ + "img/diagrama.be243525.png";